import { TColors } from '@cian/ui-kit-design-tokens/colors';

import { TLabelColor, ELabelColor } from '../../types';

export const labelBgColorMap: Record<ELabelColor, string> = {
  [ELabelColor.Red]: 'surface-negative-default',
  [ELabelColor.Green]: 'surface-positive-default',
  [ELabelColor.DarkGreen]: 'accent-positive-primary',
  [ELabelColor.Blue]: 'accent-main-secondary',
  [ELabelColor.Gray]: 'gray10_100',
  [ELabelColor.DarkGray]: 'gray6_100',
  [ELabelColor.Yellow]: 'surface-warning-default',
  [ELabelColor.SimpleBlue]: 'accent-main-secondary',
  [ELabelColor.DarkBlue]: 'accent-main-primary',
  // TODO: Применить новые переменные после обновления на последний кит.
  [ELabelColor.BlackBlueGradient]: 'linear-gradient(90deg, black 0%, #0766fc 100%), rgba(4, 104, 255, 0.1)',
  [ELabelColor.BlueVerifiedByCian]: 'accent-main-primary',
  [ELabelColor.Purple]: 'rgba(135, 41, 255, 0.10)',
};

export const labelTextColorMap: Record<ELabelColor, string> = {
  [ELabelColor.Red]: 'accent-negative-primary',
  [ELabelColor.Green]: 'accent-positive-primary',
  [ELabelColor.DarkGreen]: 'theme-white',
  [ELabelColor.Blue]: 'accent-main-primary',
  [ELabelColor.Gray]: 'theme-dark',
  [ELabelColor.DarkGray]: 'theme-dark',
  [ELabelColor.Yellow]: 'accent-warning-primary',
  [ELabelColor.SimpleBlue]: 'accent-main-primary',
  [ELabelColor.DarkBlue]: 'theme-white',
  [ELabelColor.BlackBlueGradient]: 'theme-white',
  [ELabelColor.BlueVerifiedByCian]: 'theme-white',
  [ELabelColor.Purple]: 'var(--decorative-purple)',
};

export function mapLabelBgColor(color: TLabelColor): string {
  return labelBgColorMap[color];
}

export function mapLabelColor(color: TLabelColor) {
  return labelTextColorMap[color] as TColors;
}
